import { Rect } from '@st/geom'
import { ReactNode } from 'react'

type Props = {
  bounds: Rect
  onClick?: () => void
  onDoubleClick?: () => void
  children: ReactNode
}
export function ViewElementContainer({ bounds, children, onClick, onDoubleClick }: Props) {
  return (
    <div
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation()
              e.preventDefault()

              onClick()
            }
          : undefined
      }
      onDoubleClick={
        onDoubleClick
          ? (e) => {
              e.stopPropagation()
              e.preventDefault()

              onDoubleClick()
            }
          : undefined
      }
      style={{
        position: 'absolute',
        boxSizing: 'border-box',
        top: bounds.y,
        left: bounds.x,
        width: bounds.width,
        height: bounds.height,
        cursor: onClick ? 'pointer' : undefined
      }}
    >
      {children}
    </div>
  )
}
